import { IntlShape, SupportedLocaleCode } from '@futrli/localisation';
import { intlEnGB, intlFrFR, intlFrCA, intlEnTest1, intlEnTest2 } from '@futrli/localisation/core';

const locales: Record<SupportedLocaleCode, IntlShape> = {
  'en-GB': intlEnGB,
  'fr-FR': intlFrFR,
  'fr-CA': intlFrCA,
  'en-test1': intlEnTest1,
  'en-test2': intlEnTest2
};
export const formulaFuncLangMap: () => Record<string, Record<SupportedLocaleCode, string>> = () => ({
  'SUM': Object.fromEntries(
    Object.entries(locales).map(([localeKey, intl]) => [
      localeKey,
      intl.formatMessage({ id: 'formula.sum', defaultMessage: 'SUM' })
    ])
  ) as Record<SupportedLocaleCode, string>,
  'Reference': Object.fromEntries(
    Object.entries(locales).map(([localeKey, intl]) => [
      localeKey,
      intl.formatMessage({ id: 'formula.reference', defaultMessage: 'Reference' })
    ])
  ) as Record<SupportedLocaleCode, string>,
  'DATE': Object.fromEntries(
    Object.entries(locales).map(([localeKey, intl]) => [
      localeKey,
      intl.formatMessage({ id: 'formula.date', defaultMessage: 'DATE' })
    ])
  ) as Record<SupportedLocaleCode, string>,
  'year': Object.fromEntries(
    Object.entries(locales).map(([localeKey, intl]) => [
      localeKey,
      intl.formatMessage({ id: 'formula.year', defaultMessage: 'year' })
    ])
  ) as Record<SupportedLocaleCode, string>,
  'month': Object.fromEntries(
    Object.entries(locales).map(([localeKey, intl]) => [
      localeKey,
      intl.formatMessage({ id: 'formula.month', defaultMessage: 'month' })
    ])
  ) as Record<SupportedLocaleCode, string>,
  'day': Object.fromEntries(
    Object.entries(locales).map(([localeKey, intl]) => [
      localeKey,
      intl.formatMessage({ id: 'formula.day', defaultMessage: 'day' })
    ])
  ) as Record<SupportedLocaleCode, string>,
  'IF': Object.fromEntries(
    Object.entries(locales).map(([localeKey, intl]) => [
      localeKey,
      intl.formatMessage({ id: 'formula.if', defaultMessage: 'IF' })
    ])
  ) as Record<SupportedLocaleCode, string>,
  'AVG': Object.fromEntries(
    Object.entries(locales).map(([localeKey, intl]) => [
      localeKey,
      intl.formatMessage({ id: 'formula.avg', defaultMessage: 'AVG' })
    ])
  ) as Record<SupportedLocaleCode, string>,
  'MIN': Object.fromEntries(
    Object.entries(locales).map(([localeKey, intl]) => [
      localeKey,
      intl.formatMessage({ id: 'formula.min', defaultMessage: 'MIN' })
    ])
  ) as Record<SupportedLocaleCode, string>,
  'MAX': Object.fromEntries(
    Object.entries(locales).map(([localeKey, intl]) => [
      localeKey,
      intl.formatMessage({ id: 'formula.max', defaultMessage: 'MAX' })
    ])
  ) as Record<SupportedLocaleCode, string>,
  'ON DATE': Object.fromEntries(
    Object.entries(locales).map(([localeKey, intl]) => [
      localeKey,
      intl.formatMessage({ id: 'formula.on_date', defaultMessage: 'ON DATE' })
    ])
  ) as Record<SupportedLocaleCode, string>,
  'YEAR': Object.fromEntries(
    Object.entries(locales).map(([localeKey, intl]) => [
      localeKey,
      intl.formatMessage({ id: 'formula.year', defaultMessage: 'year' }).toUpperCase()
    ])
  ) as Record<SupportedLocaleCode, string>,
  'MONTH': Object.fromEntries(
    Object.entries(locales).map(([localeKey, intl]) => [
      localeKey,
      intl.formatMessage({ id: 'common.month', defaultMessage: 'month' }).toUpperCase()
    ])
  ) as Record<SupportedLocaleCode, string>,
  'DAYOFMONTH': Object.fromEntries(
    Object.entries(locales).map(([localeKey, intl]) => [
      localeKey,
      intl.formatMessage({ id: 'formula.day_of_month', defaultMessage: 'DAYOFMONTH' })
    ])
  ) as Record<SupportedLocaleCode, string>,
  'LASTMONTH': Object.fromEntries(
    Object.entries(locales).map(([localeKey, intl]) => [
      localeKey,
      intl.formatMessage({ id: 'formula.last_month', defaultMessage: 'LASTMONTH' })
    ])
  ) as Record<SupportedLocaleCode, string>,
  'LASTYEAR': Object.fromEntries(
    Object.entries(locales).map(([localeKey, intl]) => [
      localeKey,
      intl.formatMessage({ id: 'formula.last_year', defaultMessage: 'LASTYEAR' })
    ])
  ) as Record<SupportedLocaleCode, string>,
  'condition': Object.fromEntries(
    Object.entries(locales).map(([localeKey, intl]) => [
      localeKey,
      intl.formatMessage({ id: 'formula.condition', defaultMessage: 'condition' })
    ])
  ) as Record<SupportedLocaleCode, string>,
  'true': Object.fromEntries(
    Object.entries(locales).map(([localeKey, intl]) => [
      localeKey,
      intl.formatMessage({ id: 'formula.true', defaultMessage: 'true' })
    ])
  ) as Record<SupportedLocaleCode, string>,
  'option A': Object.fromEntries(
    Object.entries(locales).map(([localeKey, intl]) => [
      localeKey,
      intl.formatMessage({ id: 'formula.option_A', defaultMessage: 'option A' })
    ])
  ) as Record<SupportedLocaleCode, string>,
  'option B': Object.fromEntries(
    Object.entries(locales).map(([localeKey, intl]) => [
      localeKey,
      intl.formatMessage({ id: 'formula.option_B', defaultMessage: 'option B' })
    ])
  ) as Record<SupportedLocaleCode, string>
});
